import { Controller } from "@hotwired/stimulus"
import mrujs from "mrujs"

// Sends a request on trigger (e.g. change->turbo-request#submit) and renders
// the turbo-stream response. Replaces mrujs data-remote elements (checkboxes,
// links) whose endpoints now respond with Turbo Streams — mrujs's
// navigationAdapter would otherwise morphdom the stream over the document.
// mrujs.fetch is kept only for its CSRF handling.
export default class extends Controller {
  static values = {
    url: String,
    method: { type: String, default: "post" },
    params: Object
  }

  submit(event) {
    event?.preventDefault()

    const params = { ...(this.paramsValue || {}) }

    // Include the triggering form control's current value (e.g. the chosen
    // option of a permission-level select) unless an explicit param already
    // covers it.
    const control = event?.target
    if (control?.name && !(control.name in params)) {
      params[control.name] = control.type === "checkbox" ? control.checked : control.value
    }

    mrujs
      .fetch(this.urlValue, {
        method: this.methodValue.toUpperCase(),
        headers: {
          "Content-Type": "application/json",
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: JSON.stringify(params)
      })
      .then(r => r.text())
      .then(html => window.Turbo.renderStreamMessage(html))
  }
}
